export default import.meta.ROLLDOWN_FILE_URL_2hUB2UPQ67PWoKFr6F4a1w